import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const ManageProvisioningStyles: moduleStyleType = {
    rectangle: {
        backgroundColor: '#FFFFFF',
        border: `1px solid ${palette.border.primary}`,
        borderRadius: '6px',
        display: 'flex',
        minWidth: '200px',
        maxWidth: '50%',
        marginBottom: 'auto',
        overflow: 'auto',
    },
}
